const baseUrl = process.env.REACT_APP_SKALEBOT_SERVER + "/api/v1";
export default baseUrl;
